const VISITOR_STORAGE_KEY = 'milora_ad_visitor_id';

export function getAdVisitorId(): string {
  if (typeof window === 'undefined') return '';

  try {
    const existing = localStorage.getItem(VISITOR_STORAGE_KEY);
    if (existing) return existing;

    const id =
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `v-${Date.now()}-${Math.random().toString(36).slice(2)}`;

    localStorage.setItem(VISITOR_STORAGE_KEY, id);
    return id;
  } catch {
    return '';
  }
}
